import { initDevice } from './modules/devicesHandler.js';
import { padLeft } from './modules/common.js';
import { More } from './modules/components.js';

import { initIntro } from './modules/intro.js';
import { fixedTopmenu } from './modules/fixedTopmenu.js';
import { linkHighlight } from './modules/pageLlinkFocus.js';
import { initProcessScroll } from './modules/scrollProcess.js';
import { initScrollReveal } from './modules/scrollReveal.js';
import { initGoTop } from './modules/scrollToTop_Bottom.js';


initDevice();

// 跳到首頁-交通指南 =>隱藏影片
if (window.location.hash) {
	const introContainer = document.getElementById('intro-animation');
	if (introContainer) {
		introContainer.style.display = 'none';
		introContainer.remove();
	}
	// 3. 確保滾動鎖定被解除
	document.body.classList.remove('is-intro-active');
}
// ==========

window.addEventListener('load', () => {
	fixedTopmenu();
	initProcessScroll();
	initScrollReveal();
	initGoTop();

	const playIntro = initIntro();
	const startIntro = () => {
		if (typeof playIntro === 'function') {
			playIntro();
		}
	};

	const $haveIntro = $('#intro-animation');

	const $preload = $('#preload');
	if ($preload.length > 0) {
		// 是首頁
		if ($haveIntro.length > 0) {
			if (typeof playIntro === 'function') {
				startIntro();
			};
			// 不是首頁
		} else {
			// startIntro();
			$preload.delay(500).fadeOut(500);
		}
	}


	linkHighlight([
		'.nav-topmenu a',
		'footer ul a'
	]);

	// 額外保險：強制 ScrollTrigger 校正一次
	if (window.ScrollTrigger) {
		window.ScrollTrigger.refresh();
	}
});

// 批量掛載到 window
const globals = {
	padLeft,
	More,
};

Object.assign(window, globals);